/* eslint-disable no-nested-ternary */
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from 'antd';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import {
  maxMobile,
  maxTablet,
  maxWidth, midTablet, primaryColor, primaryFont, primaryHeadingColor,
  retina, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { actions } from 'Slice/BuyerGroupsPageSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions as actionsSearch } from 'Slice/AffinitySearchResultsSlice';
import classNames from 'classnames';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import GlobalButton from 'Components/common/components/GlobalButton';
import {
  selectNoMembersPage,
  selectNotMembers,
  selectNotMembersLoad,
  selectPeopleDrawerOpen,
  selectRecommendedPeople,
  selectRecommendedEnded,
  selectType,
  selectRecommendedPage,
  selectRecommendedLoad,
  selectNoGroupMembersEnded,
  selectRecommendedPeopleCount,
  selectFollowedPeopleCount,

} from 'Selector/BuyerGroupSelector';
import { Executive } from 'Types/PersonTypes';
import {
  backgroundColorParsing, formatNumberWithCommas, getLangCookie, validateSearchQuery, valueToObject, IsMobile
} from 'Utils/UtilityFunctions';

import PeopleCardListSkeleton from 'Components/common/skeleton/PeopleCardListSkeleton';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import { selectHighlight } from 'Selector/CertificationSelector';
import { SearchResultsRequest } from 'Types/AffinitySearchTypes';
import {
  selectExtendedLoading, selectLoading, selectPeopleData, selectSearchResultsPage,
} from 'Selector/AffinitySearchSelector';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import { usePrevious } from 'Utils/hooks/usePrevious';
import { translateSkipAreas } from 'Utils/Constants';
import PersonDisplayWidget from './PersonDisplayWidget';
import ExploreSearches from './ExploreSearches';
import PlusIconSvg from 'Components/common/assets/svgIcons/PlusIconSvg';

const Wrapper = styled.div`
  position: relative;
  .modal-addMember-group {
    @media all and (max-width: ${maxMobile}){
      font-size: 10px;
      padding: 6px 10px;
      margin-top: -3px;
    }
  }
  .icon-add-member {
    background-color: #001760;
    width: 30px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    svg {
    width: 12px;
    height: 13px;
    }
  }
`;

const Heading = styled.h3`
  font-family: ${secondaryFont};
  font-size: 46px;
  line-height: 44px;
  color: ${primaryHeadingColor};
  font-weight: ${wMBold};
  margin-bottom: 0px;
  white-space: pre;
  padding-left: 50px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 32px;
    line-height: 30px;
  }
  @media all and (max-width:${maxTablet}) {
    padding: 0 10px;
    display: inline-block;
    &:nth-child(1) {
      margin-left: 20px;
      padding: 0 5px 0 10px;
    }
    &:nth-child(2) {
      padding: 0px;
    }
  }
  @media all and (max-width: ${maxMobile}){
    font-size: 20px;
    line-height: 22px;
  }
  &.mb-head {
    margin-bottom: 30px;
     @media all and (max-width: ${maxMobile}){
      margin-bottom: 16px;
    }
  }
`;

const SearchWrapper = styled.div`
 padding: 0px 27px 0px 38px;
 display: flex;
 flex-direction: column;
 @media all and (max-width: ${maxMobile}){
    padding: 0px 27px 0px 39px;
 }
 @media all and (max-width: ${maxWidth}) , ${retina} {
     padding: 0px 27px 0px 39px;
  }
 .ant-input-affix-wrapper {
  height: 35px;
  margin-bottom: -5px;
  .ant-input-prefix {
    .anticon-search {
      font-size: 17px;
    }
    .ant-input {
      padding-bottom: 0px !important;
    }
  }
 }
 .heading-div {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
 }
 .heading-green {
  font-family: ${primaryFont};
  font-weight: ${wMBold};
  font-size: 14px;
  line-height: 22px;
  color: ${primaryColor};
  cursor: pointer;
 }
 .heading {
   color: ${primaryHeadingColor};
   font-family: ${secondaryFont};
   font-size: 24px;
   line-height: 34px;
   font-weight: ${wMBold};
   white-space: pre;
 }
 @media all and (max-width: ${maxTablet}) {
  padding: 0 18px;
 }
  .search-result{
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 20px;
    @media all and  (max-width: ${maxWidth}), ${retina}{
      margin-top: 20px;
      margin-bottom: 14px;
    }
    @media all and  (max-width: ${maxMobile}){
      margin-bottom: 0px;
    }
   .icon-span{
    margin-right: 13px;
    margin-top: 5px;
    margin-left: 11px;
    .c-pointer{
      width: 17px;
      height: 17px;
    }
   }
   .separator{
    margin-right: 5px;
    color: #dddddd;
   }
   .para-result{
    font-weight: ${wMBold};
    font-size: 24px;
    margin: 0px 10px;
    color: #1EC252;
    font-family: ${secondaryFont};
    @media all and (max-width: ${maxMobile}) {
      font-size: 14px;
      margin: 0px 5px;
    }
   }
 }
`;

const TabsWrapper = styled.div`
margin: 15px 27px 20px 39px;
height: 35px;
display: flex;
border: 1px solid #DADADA;
border-radius: 4px;
overflow: hidden;
width: calc(100% - 65px);
@media screen and (max-width: ${midTablet}){
  margin: 19px 23px 0px 23px !important;
}
@media all and (max-width: ${maxWidth}) , ${retina} {
    margin: 14px 28px 20px 39px;     
}
`;

const Tab = styled.span<{ active: boolean }>`
  width: 50%;
  min-width: 50%;
  border-right: 1px solid #dadada;
  flex: 1;
  padding: 3px 10px;
  text-align: center;
  font-family: ${secondaryFont};
  font-weight: ${wMedium};
  font-size: 16px;
  line-height: 25px;
  cursor: pointer;
  background-color: ${(props) => (props.active ? '#E2F5E7' : 'transparent')};
  color: ${(props) => (props.active ? '#1EC252' : '#424B50')};
  font-weight: ${(props) => (props.active ? wMBold : wMedium)};
  &.active{
    font-weight: ${wMBold};
  }
  @media screen and (max-width : ${maxMobile} ){
   font-size: 12px;
  }
`;

const BrowseAll = styled.span`
 cursor: pointer;
`;

type Props = {
  groupId: number,
  showDrawer?: boolean
} & typeof defaultProps;

const defaultProps = {
  showDrawer: false,
};

const DrawerPeopleBrowse = function DrawerPeopleBrowse(props: Props) {
  const { groupId, showDrawer } = props;
  const dispatch = useDispatch();
  const visible = useSelector(selectPeopleDrawerOpen);
  const members = useSelector(selectNotMembers);
  const recommendedPeople = useSelector(selectRecommendedPeople);
  const recommendedEnded = useSelector(selectRecommendedEnded);
  const noGroupMembersEnded = useSelector(selectNoGroupMembersEnded);
  const recomendedPeopleCount = useSelector(selectRecommendedPeopleCount);
  const followedPeopleCount = useSelector(selectFollowedPeopleCount);
  const [searchTerm, setSearchTerm] = useState('');
  const { persons } = useSelector(selectPeopleData);
  const searchPage = useSelector(selectSearchResultsPage);
  const notMembersLoading = useSelector(selectNotMembersLoad);
  const recommendedLoading = useSelector(selectRecommendedLoad);
  const searchLoading: boolean = useSelector(selectLoading);
  const extendedLoading: boolean = useSelector(selectExtendedLoading);
  const page = useSelector(selectNoMembersPage);
  const type = useSelector(selectType);
  const recommendedPage = useSelector(selectRecommendedPage);
  const isHighlight = useSelector(selectHighlight);
  const [isRecommendedTab, setIsRecommendedTab] = useState<boolean>(true);
  const [dataLength, setDataLength] = useState<number>(0);
  const prevRecommendedLength = usePrevious<number>(recommendedPeople.length);
  const host = window.location.href;
  const formattedRecomendedPeopleCount = formatNumberWithCommas(recomendedPeopleCount);
  const formattedFollowedPeopleCount = formatNumberWithCommas(followedPeopleCount);
  const isMob = IsMobile();

  useEffect(() => {
    if (searchTerm.length) {
      setDataLength(persons?.length ?? 0);
    } else if (isRecommendedTab) {
      setDataLength(recommendedPeople?.length);
    } else {
      setDataLength(members?.length);
    }
  }, [searchTerm, recommendedPeople, members]);

  useEffect(() => {
    setTimeout(() => {
      const node = document.querySelector('body');
      return visible ? node?.classList.add('body-drawer-toggle-account-plan') : node?.classList.remove('body-drawer-toggle-account-plan');
    }, 500);
  }, [visible]);

  const sendSearchCall = (keyword: string, count = 1) => {
    const obj: SearchResultsRequest = {
      query: keyword.trim(),
      screenName: 'group',
      page: count,
      group_id: groupId,
      defaultLanguage: getLangCookie(),
    };
    dispatch(actionsSearch.affinitySearchResultsLoading(obj));
  };

  useEffect(() => {
    if (visible) {
      if (!searchTerm.length) {
        if (isRecommendedTab) {
          if (!recommendedEnded && !recommendedPeople?.length && !recommendedLoading) {
            dispatch(actions.getRecommendedPeople({
              groupId,
              ...(recommendedPage ? { page: recommendedPage } : {}),
              ...(type ? { type } : {}),
            }));
            dispatch(actions.getMembersNotInGroup({
              groupId,
              page,
            }));
          }
        }
      }
    } else {
      dispatch(actions.resetNoGroupMembers());
      dispatch(actions.resetRecommendedPeople());
      setIsRecommendedTab(true);
      setSearchTerm('');
    }
  }, [visible, isRecommendedTab, searchTerm]);

  const toggle = () => {
    dispatch(actions.setPeopleDraweropen(!visible));
    dispatch(actions.clearStates());
    if (!visible) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('clicked_addMember_buyerGroup', 0, {
          group_id: groupId,
          host,
        }),
      ));
    }
  };

  useEffect(() => {
    if (!recommendedPeople.length && !searchTerm
      && isRecommendedTab && !recommendedEnded && visible
      && !recommendedLoading && prevRecommendedLength) {
      dispatch(actions.getRecommendedPeople({
        groupId,
        ...(recommendedPage ? { page: recommendedPage } : {}),
        ...(type ? { type } : {}),
      }));
    }
  }, [recommendedPeople]);

  const getMorePeople = () => {
    if (visible) {
      if (searchTerm.length) {
        if (!searchLoading) {
          sendSearchCall(searchTerm, searchPage + 1);
        }
      } else if (isRecommendedTab) {
        if (!recommendedEnded && !recommendedLoading) {
          dispatch(actions.getRecommendedPeople({
            groupId,
            ...(recommendedPage ? { page: recommendedPage } : {}),
            ...(type ? { type } : {}),
          }));
        }
      } else if (!noGroupMembersEnded && !notMembersLoading) {
        dispatch(actions.getMembersNotInGroup({
          groupId,
          page,
        }));
      }
    }
  };
  const onSearching = (keyword: string) => {
    if (keyword.length) {
      const searchQuery = validateSearchQuery(keyword.trim());
      if (searchQuery.length === 0 || searchQuery === searchTerm) {
        return;
      }
      setSearchTerm(searchQuery);
      dispatch(actionsSearch.affinitySearchResultReset());
      sendSearchCall(searchQuery, 1);
    } else {
      setSearchTerm('');
      dispatch(actionsSearch.affinitySearchResultReset());
    }
  };

  useEffect(() => {
    if (groupId) { setSearchTerm(''); }
  }, [groupId]);

  useEffect(() => {
    if (showDrawer) {
      dispatch(actions.setPeopleDraweropen(true));
    }
  }, [showDrawer]);

  const showSkeleton = () => (
    [1, 2, 3, 4, 5].map(() => (
      <PeopleCardListSkeleton />
    ))
  );

  const personIsAdded = (flag: boolean) => {
    if (searchTerm.length) {
      return !flag;
    }
    return flag;
  };

  const onBackClick = () => {
    setSearchTerm('');
    dispatch(actionsSearch.affinitySearchResultReset());
  };

  return (
    <Wrapper>
      <BrowseAll onClick={toggle} className={classNames({ drawerBoxOpen: visible })}>
        {isMob ?
          <div className='icon-add-member'>
            <PlusIconSvg fillColor="#fff" className="icon" />
          </div> :
          <GlobalButton
            title="Add members"
            textColor="#ffffff"
            bgColor="#001760"
            borderRadius="8px"
            PaddingSm="6px 15px 7px"
            innerSpace="6px 15px 6px"
            fontSize="12px"
            buttonClassName="modal-addMember-group"

          />
        }
      </BrowseAll>
      <Drawer
        rootClassName={classNames(
          'drawer-alerts people-group-drawer people-browse-drawer',
          { indexZero: isHighlight },
        )}
        placement="right"
        open={visible}
        onClose={toggle}
        width={530}
        extra={(
          <span onClick={toggle} onKeyPress={toggle} tabIndex={0} role="button" aria-label="close" className="close-alerts"><CloseAlerts /></span>
        )}
      >
        <Heading>People</Heading>
        <Heading className="mb-head">browser</Heading>
        <SearchWrapper>
          <AlertsSearch
            placeholderText="Filter and search people..."
            loading={false}
            query={searchTerm}
            onSearching={onSearching}
            margin="0px"
            height="30px"
          />
          {searchTerm.length ? (
            <div className="search-result">
              <span className="icon-span">
                <BackIcon onClick={onBackClick} />
              </span>
              <span className="separator">|</span>
              <p className="para-result">Search Results</p>
            </div>
          ) : null}
        </SearchWrapper>
        {!searchTerm.length ? (
          <TabsWrapper>
            <Tab active={isRecommendedTab} onClick={() => { setIsRecommendedTab(true); }} className="text-truncate">
              Recommended
              {recomendedPeopleCount ? <span className={` ${translateSkipAreas}`}>{` (${formattedRecomendedPeopleCount})`}</span> : null}
            </Tab>
            <Tab active={!isRecommendedTab} onClick={() => { setIsRecommendedTab(false); }} className="text-truncate">
              My Network
              {followedPeopleCount ? <span className={` ${translateSkipAreas}`}>{` (${formattedFollowedPeopleCount})`}</span> : null}
            </Tab>
          </TabsWrapper>
        ) : null}
        <div id="people-wrapper" className="h-100 list-data-recommended">
          <div className={classNames('results-toggle', { showRecommended: isRecommendedTab })}>
            {!searchTerm.length ? (
              <InfiniteScroll
                hasMore
                dataLength={dataLength}
                next={getMorePeople}
                loader={false}
                className={classNames('groups-wrapper o-x-hidden scroll-area-for-drawer', { 'no-people': recommendedPeople?.length === 0 && !recommendedLoading })}
                height="auto"
              >
                {recommendedPeople?.map((v: Executive) => (
                  <PersonDisplayWidget
                    personId={v.personId}
                    title={v.personName}
                    profilePic={v.personImage}
                    persona={backgroundColorParsing(v.personalityTypes)}
                    company={v.companyName}
                    designation={v.personDesignation}
                    isPersonAdded={personIsAdded(v.personAdded)}
                    isFollowed={v.personAdded}
                    personType={v.personType}
                    isRecommended
                    clicked={v.isAddClicked}
                    companyId={v?.companyId}
                    location={v?.location}
                  />
                ))}
                {recommendedLoading
                  ? showSkeleton() : null}
                {isRecommendedTab && !recommendedPeople?.length
                  && !recommendedLoading && !searchTerm
                  && visible && recommendedEnded ? <ExploreSearches /> : null}
              </InfiniteScroll>
            ) : null}
          </div>
          <div className={classNames('not-recommended-result-toggle', { showRecommended: !isRecommendedTab })}>
            {!searchTerm.length ? (
              <InfiniteScroll
                hasMore
                dataLength={dataLength}
                next={getMorePeople}
                loader={false}
                className={classNames('groups-wrapper o-x-hidden scroll-area-for-drawer', { 'no-people': members?.length === 0 && !notMembersLoading })}
                height="auto"
              >
                {members?.map((v: Executive) => (
                  <PersonDisplayWidget
                    key={v.personId}
                    personId={v.personId}
                    title={v.personName}
                    profilePic={v.personImage}
                    persona={backgroundColorParsing(v.personalityTypes)}
                    company={v.companyName}
                    designation={v.personDesignation}
                    isPersonAdded={personIsAdded(v.personAdded)}
                    isFollowed={v.personAdded}
                    personType={v.personType}
                    clicked={v.isAddClicked}
                    isNetwork
                    companyId={v?.companyId}
                    location={v?.location}
                  />
                ))}
                {notMembersLoading
                  ? showSkeleton() : null}
                {members?.length === 0 && !notMembersLoading && noGroupMembersEnded && visible ? <NoPersonsFound title="No Person Found" /> : null}
              </InfiniteScroll>
            ) : null}
          </div>
          {searchTerm.length ? (
            <InfiniteScroll
              hasMore
              dataLength={dataLength}
              next={getMorePeople}
              loader={false}
              className={classNames('groups-wrapper o-x-hidden scroll-area-for-drawer', { 'no-people': persons?.length === 0 && !searchLoading && !extendedLoading })}
              height="auto"
            >
              {persons?.map((v: Executive) => (
                <PersonDisplayWidget
                  key={v.personId}
                  personId={v.personId}
                  title={v.personName}
                  profilePic={v.personImage}
                  persona={backgroundColorParsing(v.personalityTypes)}
                  company={v.companyName}
                  designation={v.personDesignation}
                  isPersonAdded={personIsAdded(v.personAdded)}
                  isFollowed={v.personAdded}
                  personType={v.personType}
                  companyId={v?.companyId}
                  location={v?.location}
                />
              ))}
              {searchLoading
                ? showSkeleton() : null}
              {(extendedLoading && !searchLoading) && <PeopleCardListSkeleton />}
              {persons?.length === 0 && !searchLoading && !extendedLoading && searchTerm && visible ? <NoPersonsFound title="No Person Found" /> : null}
            </InfiniteScroll>
          ) : null}
        </div>
      </Drawer>
    </Wrapper>
  );
};
DrawerPeopleBrowse.defaultProps = defaultProps;
export default DrawerPeopleBrowse;
